import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SrOperationService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 1606 */
    public async getActivity(): Promise<SrActivityGet> { return (await this.datatask.Post(1606, {}))[0]; }
    /** @datatask 1607 */
    public getActivityList(page: SrActivityGet): Promise<Item[]> { return this.datatask.Post(1607, page); }

    /** @datatask 1316 */
    public async getOperation(params: SrOperationParams): Promise<SrOperationGet> { return (await this.datatask.Post(1316, params))[0]; }
    /** @datatask 1317 */
    public getResources(params: SrOperationParams): Promise<Item[]> { return this.datatask.Post(1317, params); }
    /** @datatask 1318 */
    public getReports(params: SrOperationParams): Promise<Item[]> { return this.datatask.Post(1318, params); }
    /** @datatask 1483 */
    public async getReport(params: SrOperationParams): Promise<SrOperationAddrGet> { return (await this.datatask.Post(1483, params))[0]; }
    /** @datatask 1484 */
    public getReportResources(params: SrOperationParams): Promise<SrOperationResourceItem[]> { return this.datatask.Post(1484, params); }
    /** @datatask 2138 */
    public getReportChecklists(page: SrOperationAddrGet): Promise<Item[]> { return this.datatask.Post(2138, page); }
    /** @datatask 2139 */
    public async saveReport(page: SrOperationAddrGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2139, page))[0]; }
    /** @datatask 1472 */
    public async getResourceSelection(params: SrOperationParams): Promise<SrOperationArGet> { return (await this.datatask.Post(1472, params))[0]; }
    /** @datatask 1473 */
    public getSuperiorResources(): Promise<SrOperationResourceItem[]> { return this.datatask.Post(1473, {}); }
    /** @datatask 1474 */
    public getSelectableResources(page: SrOperationArGet): Promise<SrOperationSelectableResource[]> { return this.datatask.Post(1474, page); }
    /** @datatask 1475 */
    public async addResources(page: SrOperationArSave): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1475, page))[0]; }
    /** @datatask 1476 */
    public async getResource(params: SrOperationResourceParams): Promise<SrOperationResourceGet> { return (await this.datatask.Post(1476, params))[0]; }
    /** @datatask 1477 */
    public async deleteResource(page: SrOperationResourceGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1477, page))[0]; }
    /** @datatask 2140 */
    public async getManualOperation(): Promise<SrOperationManualAddGet> { return (await this.datatask.Post(2140, {}))[0]; }
    /** @datatask 2142 */
    public getOperationNumbers(): Promise<Item[]> { return this.datatask.Post(2142, {}); }
    /** @datatask 2143 */
    public getManualResources(): Promise<Item[]> { return this.datatask.Post(2143, {}); }
    /** @datatask 2141 */
    public async saveManualOperation(page: SrOperationManualAddGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2141, page))[0]; }
    /** @datatask 1319 */
    public async getOperations(): Promise<SrOperationsGet> { return (await this.datatask.Post(1319, {}))[0]; }
    /** @datatask 1320 */
    public getOperationList(page: SrOperationsGet): Promise<Item[]> { return this.datatask.Post(1320, page); }
}

export interface SrOperationParams { custact_no: string; }
export interface SrActivityGet { resource_id: string; resource_searchtext: string; only_this_resource: string; datetime_fom: string; }
export interface SrOperationGet extends SrOperationParams {
    special_hrsno: string;
    special_phase_name: string;
    special_coordinator_name: string;
    special_event_name: string;
    special_where: string;
    special_object: string;
    special_objectnumber: string;
    show_foreflight_pos: '0' | '1';
    foreflight_pos: string;
    maplink_external: string;
    maplink_external_mtbmap: string;
    show_button_refundbasis: '0' | '1';
    nbr_of_expenses: string | number;
    show_add_new_resource: '0' | '1';
    show_add_new_report: '0' | '1';
}
export interface SrOperationAddrGet extends SrOperationParams { resource_id: string; checklist_keyno: string; note: string; }
export interface SrOperationResourceItem { resource_id: string; resource_name: string; }
export interface SrOperationArGet extends SrOperationParams {
    webpage_heading: string;
    resource_id_superior: string;
    first_alert_dt: string;
    filtervalue: string;
}
export interface SrOperationSelectableResource extends Item { item_id: string; item_is_selected: '0' | '1'; }
export interface SrOperationResourceSelection { item_id: string; item_is_selected: '0' | '1'; }
export interface SrOperationArSave extends SrOperationArGet { records: SrOperationResourceSelection[]; }
export interface SrOperationResourceParams { special_hrs_custactresource_keyno: string; }
export interface SrOperationResourceGet extends SrOperationResourceParams {
    resource_id: string;
    resource_name: string;
    show_button_crew: '0' | '1';
    nbr_of_crews: string | number;
    show_button_delete: '0' | '1';
}
export interface SrOperationManualAddGet {
    w_sroperationmanualadd_info: string;
    special_hrsno: string;
    first_alert_dt: string;
    special_resource_id_to_add: string;
}
export interface SrOperationsGet {
    bg_sroperations_view: string;
    refresh_active: '0' | '1';
    date_fom: string;
    date_tom: string;
    dateselector_index: string;
    date_fomtom: string;
    resource_id: string;
    resource_searchtext: string;
    searchtext: string;
    show_manualadd: '0' | '1';
}
